import { render, staticRenderFns } from "./AddCollege.vue?vue&type=template&id=d276a89a"
import script from "./AddCollege.vue?vue&type=script&lang=js"
export * from "./AddCollege.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports